import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { actionState, popupState } from "../../../../Store/atoms";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";

import "./../popup.css";
import "./styles.css";

interface IConfirmActionPopupProps {
  message: string;
}
const useStyles = makeStyles({
  deleteButton: {
    backgroundColor: "#dc3545",
    color: "white",
    marginLeft: "2rem",
    "&:hover": {
      color: "white",
      backgroundColor: "#a3001e",
    },
  },

  closeButton: {
    marginRight: "2rem",
  },
});

export default ({ message }: IConfirmActionPopupProps) => {
  const classes = useStyles();
  const action = useRecoilValue(actionState);
  const setPopup = useSetRecoilState(popupState);

  blurRoot();

  const handleClose = () => {
    unBlurRoot();
    setPopup(null);
  };

  const handleConfirm = async () => {
    if (action) {
      await action.action();
    }
    unBlurRoot();
    setPopup(null);
    window.location.reload();
  };

  return (
    <div className="general-popup popup--confirm">
      <div className="confirm-popup__message">{message}</div>
      <div className="control-buttons--confirm">
        <Button
          className={classes.closeButton}
          onClick={handleClose}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          className={classes.deleteButton}
          onClick={handleConfirm}
          variant="contained"
        >
          Confirm
        </Button>
      </div>
    </div>
  );
};
